export default "<div ng-show=\"commandEnabled\">\n    When Set Position is selected, click anywhere in the map to set a fixed position tag there.\n</div>";